// Merge a fresh fetch of projects into the dashboard's store, keyed by project id (6 Oct 2026).
// The first load binds `projects` as an ARRAY (vuexfire); later loads used to spread that array into an object,
// which keys its entries by index, so every re-fetched project ended up in the store twice (Josh's report).
// reduce, not Object.fromEntries: the build's babel-polyfill (core-js 2) has no fromEntries for older iPads.
// eslint-disable-next-line import/prefer-default-export
export function mergeProjects(current, fetched) {
    const byId = Array.isArray(current)
        ? current.filter(Boolean).reduce((acc, p) => { acc[p.id] = p; return acc; }, {})
        : Object.assign({}, current || {});
    const merged = Object.assign(byId, fetched || {});
    return Object.keys(merged)
        .sort((a, b) => new Date(merged[b].lastChangedDate) - new Date(merged[a].lastChangedDate))
        .reduce((acc, id) => { acc[id] = merged[id]; return acc; }, {});
}



// WEBPACK FOOTER //
// ./src/lib/merge-projects.js